// Test IDs for onboarding components

export const ON_BOARDING_ITEM_TEST_IDS = {
  CONTAINER: 'onBoardingContainer',
  START_DESIGNING: 'onboarding-start-designing',
} as const;

export const ON_BOARDING_TIP_ITEM_TEST_IDS = {
  TOOLTIP_INFO: 'onboarding-tooltip-info',
  TOOLTIP_FILTER: 'onboarding-tooltip-filter',
} as const;

